
export enum AddressType {
  Address = 'Address',
  KnownPostalLocation = 'KnownPostalLocation',
}
